import { RouteRecordRaw } from 'vue-router';

import { LAYOUTS, ROUTE_NAMES } from '@/constants';
import InventoryInsights from '@/pages/FeatureEnrollment/InventoryInsights/InventoryInsights.vue';
import i18n, { loadTranslations } from '@/plugins/i18n';

const fetchTranslations = async () => {
  await Promise.all([loadTranslations('enrollment'), loadTranslations('settings')]);
};

const enrollmentRoutes: RouteRecordRaw[] = [
  {
    path: 'inventory-insights-enrollment/',
    name: ROUTE_NAMES.INVENTORY_INSIGHTS_ENROLLMENT,
    component: InventoryInsights,
    beforeEnter: [fetchTranslations],
    meta: {
      layout: LAYOUTS.FULL,
      permissions: [
        {
          rules: [
            'retail_category_management_self_service',
            ({ userActiveCompany }) => Boolean(userActiveCompany?.staffId),
          ],
        },
      ],
      title: i18n.t('enrollment.inventoryInsights.title'),
    },
  },
];

export default enrollmentRoutes;
